import { render, staticRenderFns } from "./TacticBoard.vue?vue&type=template&id=2d860bf8&"
import script from "./TacticBoard.vue?vue&type=script&lang=js&"
export * from "./TacticBoard.vue?vue&type=script&lang=js&"
import style0 from "./TacticBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports